const config =  {
  FEATURE_FLAGS: {
    useSpreadsheet: localStorage.__use_jspreadsheet === 'true',
    useMixpanel:  localStorage.__use_mixpanel !== 'false',
    useArppuTable:  localStorage.__use_arppu_table === 'true',
  }
};

export default config;